const routes = [
  {
    path: '/',
    component: () => import('layouts/MainLayout.vue'),
    children: [
      { path: '', name: 'Home', component: () => import('pages/Index.vue') },
      { path: '/order', name: 'ViewOrder', component: () => import('pages/Order.vue') },
      { path: '/complete', name: 'ViewOrderSummary', component: () => import('pages/Complete.vue') },
      { path: '/auth', name: 'Authentication', component: () => import('pages/Auth.vue') },
      { path: '/payment', name: 'Payment', component: () => import('pages/Payment.vue') },
      { path: '/settings', name: 'ViewSettings', component: () => import('pages/Settings.vue') },
      { path: '/category/:id', name: 'ViewCategory', component: () => import('pages/Category.vue') },
      { path: '/category/:categoryId/:productId', name: 'ViewProduct', component: () => import('pages/Product.vue') },
      { path: '/page/:codename', name: 'Page', component: () => import('pages/Page.vue') },
      { path: '/contact', name: 'Contact', component: () => import('pages/Contact.vue') },
      { path: '/application', name: 'Application', component: () => import('pages/Application.vue') },
      { path: '/catering', name: 'Catering', component: () => import('pages/Catering.vue') },
    ],
  },

  {
    path: '/closed',
    component: () => import('layouts/Closed'),
    children: [
      { path: '', name: 'closed', component: () => import('pages/Closed.vue') },
    ],
  },

  // Always leave this as last one,
  // but you can also remove it
  {
    path: '*',
    component: () => import('pages/Error404.vue'),
  },
];

export default routes;
